import CircleDiagram from "./CircleDiagra";
import Products from "../sales_all/Products";

export default function Diagrams({data}) {
    let result = {
        on: 0,
        pb95: 0,
        lpg: 0,
        onplus: 0,
        pb98: 0,
        adb: 0
    };
    for(const i of data) {    
        result.on += new Number(i.today.products[4243].volume);
        result.pb95 += new Number(i.today.products[4241].volume);
        result.lpg += new Number(i.today.products[4244].volume);
        result.onplus += new Number(i.today.products[4242].volume);
        result.pb98 += new Number(i.today.products[9521].volume);
        result.adb += new Number(i.today.products[4245].volume);
    };
    
    return (
        <div className="homepage-diagrams all-container">
            <CircleDiagram data={result}/>
            <Products data={data}/>
        </div>
    )
};